export default "__VITE_ASSET__a8187e03__"